export default "__VITE_ASSET__BLA5iY7m__"